export const getStandByEnv = () => {
  if (process.env.NEXT_PUBLIC_STAND === 'PROD') {
    return 'PROD';
  }
  if (process.env.NEXT_PUBLIC_STAND === 'STAGE') {
    return 'STAGE';
  }
  return 'DEV';
};

export const isProd = () => getStandByEnv() === 'PROD';

export const isStage = () => getStandByEnv() === 'STAGE';

export const isDev = () => getStandByEnv() === 'DEV';
